<ng-container
  *ngLet="{
    exact: defaultedExact | async,
    disabled: defaultedDisabled | async,
    defaultHideCount: defaultHideCount | async,
    autoFocus: defaultedAutoFocus | async,
    filterable: defaultedFilterable | async,
    options: options | async,
    optionsLoader: wrappedOptionsLoader | async,
    placeholder: defaultedPlaceholder | async,
    positionedTop: positionedTop | async,
    minSelectedCount: defaultedMinSelectedCount | async,
    multiSelect: defaultedMultiSelect | async,
    selectedAuto: selectedAuto | async,
    selectedOptionId: defaultedSelectedOptionId | async,
    selectedOptionIds: defaultedSelectedOptionIds | async,
    selectedCount: selectedCount | async,
    selectedDisplay: selectedDisplay | async,
    loadable: defaultedLoadable | async,
    inline: defaultedInline | async,
    open: openSubject | async,
    label: defaultedLabel | async,
    labelDirection: defaultedLabelDirection | async,
    help: defaultedHelp | async,
    required: defaultedRequired | async,
    wideOptions: defaultedWideOptions | async,
    tabNames: tabNames | async,
    tab: tabSubject | async,
    subs: subs | async,
    leftButtons: leftButtons | async,
    reversedRightButtons: reversedRightButtons | async
  } as vm"
>
  <deprecated-labeled-field
    [label]="vm.label"
    [labelDirection]="vm.labelDirection"
    [help]="vm.help"
    [required]="vm.required"
  >
    <div
      #dropdown
      class="dropdown"
      [class.disabled]="vm.disabled"
      [class.combined-left]="combinedLeft"
      [class.combined-right]="combinedRight"
      [class.placeholder]="!vm.disabled && !vm.selectedDisplay"
      [class.error]="error"
      [class.warning]="warning"
      [attr.tabindex]="vm.disabled ? null : 0"
      [focusOnInit]="vm.autoFocus"
      (click)="!vm.disabled && doOpen.next(!vm.open)"
    >
      <loadable
        class="loading"
        *ngIf="vm.loadable && (vm.loadable.loading || vm.loadable.erred)"
        [size]="16"
        [data]="vm.loadable"
      ></loadable>
      <ng-container
        *ngIf="!vm.loadable || (!vm.loadable.loading && !vm.loadable.erred)"
      >
        <span class="display">
          <span
            class="selected-count"
            *ngIf="!vm.defaultHideCount && vm.selectedCount > 1"
          >
            {{ vm.selectedCount }}
          </span>
          <span class="display-value" [attr.data-title]="vm.selectedDisplay">
            {{ vm.selectedDisplay || vm.placeholder || '&nbsp;' }}
          </span>
          <riv-badge
            *ngIf="vm.selectedAuto"
            [size]="'medium'"
            [variant]="'categorical-9'"
          >
            Auto
          </riv-badge>
        </span>
      </ng-container>
      <div class="chevron">
        <riv-icon [name]="'ChevronDown'" [size]="18"></riv-icon>
      </div>
    </div>
    <ng-container *ngIf="vm.open && !vm.disabled">
      <deprecated-callout
        *deprecated-callout
        class="callout"
        [class.filterable]="vm.filterable"
        [anchor]="dropdown"
        fallbackDirection="cw"
        [allowedPositions]="topAndBottomPositions"
        (actualPosition)="position.next($event)"
        (close)="close()"
        [scrollable]="false"
      >
        <div
          class="callout-inner rv-card rv-rows"
          [class.wide]="vm.wideOptions"
          [style.min-width.px]="dropdownWidth"
          #callout
        >
          <option-select
            #optionSelect
            class="select rv-rows rv-grow"
            cdkScrollable
            [recentIdentifier]="recentOptionsIdentifier"
            [disabled]="vm.disabled"
            [options]="vm.options"
            [pinned]="pinned"
            [optionsLoader]="vm.optionsLoader"
            [exact]="vm.exact"
            [filterable]="vm.filterable"
            [forceSortOnBestMatch]="forceSortOnBestMatch"
            [multiSelect]="vm.multiSelect"
            [minSelectedCount]="vm.minSelectedCount"
            [maxSelectedCount]="maxSelectedCount"
            [selectedOptionId]="vm.selectedOptionId"
            [selectedOptionIds]="vm.selectedOptionIds"
            [filterPositionBottom]="vm.positionedTop"
            [tabNames]="vm.tabNames"
            [currentTab]="vm.tab"
            [showAvatars]="showAvatars"
            (selectedOptionIdChange)="selectedOptionIdChange.next($event)"
            (selectedOptionIdsChange)="selectedOptionIdsChange.next($event)"
            (onDragEvent)="onDragEvent.next($event)"
            (onPinnedEvent)="onPinnedEvent.next($event)"
            (filterChange)="filter.next($event)"
            (tabChange)="tabSubject.next($event)"
            [draggable]="draggable"
            [dragScrollable]="dragScrollable"
            [all]="all"
            [selectedEnabled]="selectedEnabled && vm.multiSelect"
            [showAvatars]="showAvatars"
            [optionActionButton]="optionActionButton"
            [allowSelectingEmpty]="allowSelectingEmpty"
            [displayId]="displayId"
          >
            <ng-container *ngIf="nodeDirective">
              <ng-container *optionSelectNode="let node">
                <ng-container
                  *ngTemplateOutlet="
                    nodeDirective.template;
                    context: {
                      $implicit: node,
                      selectionHandler: optionSelect
                    }
                  "
                ></ng-container>
              </ng-container>
            </ng-container>
          </option-select>
          <loadable
            class="options fill"
            *ngIf="vm.loadable && (vm.loadable.loading || vm.loadable.erred)"
            [size]="16"
            [data]="vm.loadable"
          ></loadable>
          <div>
            <ng-content></ng-content>
            <div
              *ngIf="
                vm.leftButtons.length > 0 || vm.reversedRightButtons.length > 0
              "
              class="rv-card-footer rv-grid"
            >
              <div class="rv-column-6 rv-left">
                <button
                  *ngFor="let button of vm.leftButtons"
                  [disabled]="button.locked"
                  class="rv-footer-button"
                  rivButton
                  [size]="'small'"
                  [variant]="button.type ?? 'ghost'"
                  (click)="button.onClick()"
                >
                  {{ button.text }}
                </button>
              </div>
              <div class="rv-column-6 rv-right">
                <button
                  *ngFor="let button of vm.reversedRightButtons"
                  [disabled]="button.locked"
                  class="rv-footer-button"
                  rivButton
                  [size]="'small'"
                  [variant]="button.type ?? 'ghost'"
                  (click)="button.onClick()"
                >
                  {{ button.text }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </deprecated-callout>
    </ng-container>
  </deprecated-labeled-field>
</ng-container>
